import Yup from '_zari/validation/_yup'

// import TiposDeDocumentoIdentificacionConstant from 'constants/tiposDeDocumentoIdentificacion'
// import ListaDePaisesConstant from 'constants/listaDePaises'

export const ValidationSchema = Yup.object().shape({})
